import { defineQuery } from 'next-sanity';

export const getNewsSetting = defineQuery(`
 *[_type == "newsSetting"][0]{
  ...,
  heroImage {
    ...,
    "imgAsset": asset-> {
      ...
    }
  },
  pressSayings[]{
    message,
    logo
  },
  CSS, JS,
  featuredPressRelease->{
      _id,
      title,
      slug,
      editedDate,
      coverImage {
        ...,
        "imgAsset": asset-> {
          ...
        }
      },
      content,
    }
  }
  `);

export const getNews = defineQuery(`
  *[_type == 'news' && !(_id in $excludeIds)] | order(coalesce(editedDate, _updatedAt) desc)[0...6]{
  title,
  slug,
  editedDate,
  _updatedAt,
  coverImage {
    ...,
    "imgAsset": asset-> {
      ...
    }
  },
  _id
  }
  `);

export const getNewsBySlug = defineQuery(`
*[_type == 'news' && slug.current == $slug][0]{
  title,
  slug,
  editedDate,
  coverImage {
    ...,
    "imgAsset": asset-> {
      ...
    }
  },
  socialShare,
  CSS, JS,
  "randomTestimonialCount": select(
    testimonial == null => count(*[_type == "testimonial" && includeInRandom == true]),
    null
  ),
  author->{
      name
    },
  content[]{
    ...,
    markDefs[]{...,
      _type == "internalLink" => {
      "slug": @.reference->slug.current,
        "type":@.reference->_type
        }
    },
    _type == "image" => {
      ...,
      asset-> {
        ...,
      }
    }
  },
  "text": pt::text(content),
  subHeader,
  metaDescription
}
  `);

export const getNewsLoadmorePosts = defineQuery(`
  {
  "news":*[_type == 'news' &&
           (
  editedDate < $lastEditedDate
  || (editedDate == $lastEditedDate && _updatedAt > $updatedAt)
)
           && !(_id in $excludeIds)] | order(coalesce(editedDate, _updatedAt) desc) [0...$limit]{
  title,
  slug,
  editedDate,
  coverImage {
    ...,
    "imgAsset": asset-> {
      ...
    }
  },
  _id,
     editedDate,
  _updatedAt,
  },
"totalNews": count(
      *[_type == 'news' &&
           (
  editedDate < $lastEditedDate
  || (editedDate == $lastEditedDate && _updatedAt > $updatedAt)
)
           && !(_id in $excludeIds)] | order(coalesce(editedDate, _updatedAt) desc)
)
}
  `);

export const getNewsDetailSeoData = defineQuery(`
   *[_type == "news" && slug.current == $slug][0]{
   title,
   slug,
   metaDescription,
   coverImage,
   content
   }
  `);

export const getNewsListSeoData = defineQuery(`
   *[_type == "newsSetting"]{
   title,
    metaDescription,
   }
  `);

export const getAllNewsSlugs = defineQuery(`
  *[_type == "news" && defined(slug.current)][].slug.current`);
